module.exports = __webpack_public_path__ + "assets/img/u1485.c33533dd.png";